import { render } from "./Tracks.vue?vue&type=template&id=47fd903e"
import script from "./Tracks.vue?vue&type=script&lang=js"
export * from "./Tracks.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__